"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _link = require("../link");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const LinkAccordion = _ref => {
  let {
    eventKey,
    small,
    subtree
  } = _ref;
  const [collapsed, setCollapsed] = (0, _react.useState)(null);

  /* istanbul ignore next */
  const toggleClick = () => {
    if (collapsed === null) setCollapsed(false);else setCollapsed(!collapsed);
  };
  const semiState = small && !subtree.featuredColumn ? collapsed === null || collapsed ? {
    activeKey: '',
    onClick: toggleClick
  } // small initial state is collapsed
  : {
    activeKey: eventKey,
    onClick: toggleClick
  } // small expanded state
  : {
    activeKey: eventKey
  }; // large screens are not toggleable
  const accordionProps = subtree.featuredColumn ? {
    className: 'title',
    eventKey: eventKey
  } : collapsed === false ? {
    className: 'title dropdown-toggle open',
    eventKey: eventKey,
    onClick: semiState.onClick
  } : {
    className: 'title dropdown-toggle',
    eventKey: eventKey,
    onClick: semiState.onClick
  };
  const featuredClassName = subtree.featuredColumn ? ' link-panel--featured' : '';
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: `link-panel${featuredClassName} core`,
    lg: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Accordion, {
    activeKey: semiState.activeKey
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Accordion.Toggle, _extends({
    as: "p"
  }, accordionProps), subtree.columnTitle), subtree.navItems && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Accordion.Collapse, {
    eventKey: eventKey
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, subtree.navItems.map((item, idx) => /*#__PURE__*/_react.default.createElement("li", {
    key: `${item.label}-${idx}`
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: (0, _link.absolute)(item.link),
    title: item.label,
    target: item.link.target,
    rel: "noopener noreferer"
  }, item.label)))))));
};
LinkAccordion.propTypes = {
  eventKey: _propTypes.default.string.isRequired,
  small: _propTypes.default.bool.isRequired,
  /**
   * Navigation link data object for Accordion contents.
   */
  subtree: _propTypes.default.any.isRequired
};

/**
 * Implementation of an accordion of links.
 */
var _default = exports.default = LinkAccordion;